import styled from 'styled-components';
import { getColor } from 'utils/connectivity';

type InputProps = {
  $status?: string;
  size?: string;
};

export const Root = styled.div`
  display: inline-block;
  align-items: center;
  justify-content: center;
`;

export const IconContainer = styled.div`
  display: inline-block;
  justify-content: center;
  align-items: center;
`;

export const Circle = styled.div<InputProps>`
  height: ${({ size }) => size};
  width: ${({ size }) => size};
  background-color: ${({ theme, $status }) => getColor(theme, $status)};
  border-radius: 50%;
`;
